import React from 'react';
import { useLocation } from 'react-router-dom';

import ErrorBoundary from './ErrorBoundary';

function RouteErrorBoundary({ children }) {
  const { pathname } = useLocation();

  return (
    <ErrorBoundary key={pathname} variant='page'>
      {children}
    </ErrorBoundary>
  );
}

export default RouteErrorBoundary;
